import { Observable } from 'rxjs';
import { fetchCompanyListAPI } from '../../api/fetch-functions/company';
import { ICompanyType } from '../../types/record/company';
import { ListWithPromiseState } from './common/list-with-status';
import {
  fetchIdStreamGenerator,
  fetchListFnGenerator,
  listOfIdFnGenerator,
  oneIdListSetReducerGenerator,
  oneIdListSetStreamGenerator,
  updateStreamGenerator
} from './common/one-id-list';

const fetchSignal$ = fetchIdStreamGenerator();

// 仮引数のリネームのためいったん変数`f`に格納
const f = fetchListFnGenerator(fetchSignal$);
export const fetchCompanyListOf = (koumutenId: number) => f(koumutenId);

/**
 * @description
 * `fetchCompanyListOf(koumutenId)` を実行すると
 * `companyListSet$` の該当idの要素を re-fetch する．
 */
const updateCompanyList$ = updateStreamGenerator(
  fetchSignal$,
  fetchCompanyListAPI
);

const companyListSetReducer = oneIdListSetReducerGenerator<ICompanyType>();

/**
 * @description
 * すべての companyList の集合．必要になったものからfetchして蓄える．
 * 複数のcomponentで共有するため．
 */
const companyListSet$ = oneIdListSetStreamGenerator(
  updateCompanyList$,
  companyListSetReducer
);

const g = listOfIdFnGenerator(companyListSet$);
export const companyListOf = (
  koumutenId: number
): Observable<ListWithPromiseState<ICompanyType>> => {
  fetchCompanyListOf(koumutenId);
  return g(koumutenId);
};
